export enum SupportAgentToolName {
  ANALYZE_RETURN = "analyze-return",
  CANCEL_ORDER = "cancel-order",
  CHECK_ORDER_RETURN_ELIGIBILITY = "check-order-return-eligibility",
  COMPARE_PRODUCTS = "compare-products",
  CONTACT_SUPPORT = "contact-support",
  CREATE_BUNDLE = "create-bundle",
  CREATE_DISCOUNT_CODE = "create-discount-code",
  CURRENT_VIEWED_PRODUCT = "current-viewed-product",
  CUSTOMER_SIGN_IN = "customer-sign-in",
  EXECUTE_RETURN = "execute-return",
  GENERATE_PRODUCT_VISUALIZATION = "generate-product-visualization",
  GET_CART = "get-cart",
  GET_MOBILE_MESSAGE_FLOW = "get-mobile-message-flow",
  GET_RECENT_ORDERS = "get-recent-orders",
  GET_RETURN_TOTALS = "get-return-totals",
  GIFT_CARD_BALANCE = "gift-card-balance",
  HANDOFF_DETECTION = "handoff-detection",
  HANDOFF_TO_HUMAN = "handoff-to-human",
  LOOKUP_ORDER = "lookup-order",
  LOOKUP_PRODUCTS = "lookup-products",
  ORDER_TRACKING = "order-tracking",
  RECOMMEND_EXCHANGE = "recommend-exchange",
  RESEND_GIFT_CARD = "resend-gift-card",
  RESEND_RETURN_LABEL = "resend-return-label",
  RETRIEVE_SUPPORT_KNOWLEDGE = "retrieve-support-knowledge",
  RETURN_STATUS = "return-status",
  SEARCH_STORE_CATALOG = "search-store-catalog",
  STORE_POLICIES_AND_FAQ = "store-policies-and-faq",
  SUBSCRIBE_TO_BACK_IN_STOCK = "subscribe-to-back-in-stock",
  UPDATE_CART = "update-cart",
  UPDATE_MOBILE_MESSAGE_FLOW = "update-mobile-message-flow",
  UPDATE_ORDER = "update-order",
  UPDATE_ORDER_SHIPPING_ADDRESS = "update-order-shipping-address",
  WISHLIST = "wishlist",
}

export const SUPPORT_AGENT_TOOL_NAMES = Object.values(SupportAgentToolName);

/**
 * Converts a support agent tool name to a user-friendly display name
 */
export function supportAgentToolNameToDisplayName(toolName: string): string {
  return toolName
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
